/**
 * 라이브러리 카드·상세 표시 시각.
 * 문서 updated_at = 어떤 버전이든 마지막 변경. 없으면 버전 시각·created_at 폴백.
 */

const INITIAL_SAVE_MS = 2000;

const parseLibraryTime = (value) => {
  if (value == null || value === '') return 0;
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value < 1e12 ? value * 1000 : value;
  }
  if (typeof value === 'object') {
    if (typeof value.toDate === 'function') {
      const date = value.toDate();
      return date instanceof Date && !Number.isNaN(date.getTime()) ? date.getTime() : 0;
    }
    if (typeof value.seconds === 'number') {
      return value.seconds * 1000;
    }
  }
  const parsed = new Date(value);
  const ms = parsed.getTime();
  return Number.isNaN(ms) ? 0 : ms;
};

const versionTimes = (item) => {
  const summary = item?.versions_summary || {};
  const versions = item?.versions || {};
  return ['text', 'image'].map((mode) => (
    parseLibraryTime(versions[mode]?.updated_at || versions[mode]?.updatedAt || summary[mode]?.updated_at)
  ));
};

export const resolveLibraryUpdatedAt = (item) => {
  const candidates = [
    parseLibraryTime(item?.updated_at || item?.updatedAt),
    ...versionTimes(item),
    parseLibraryTime(item?.created_at || item?.createdAt),
  ];
  return candidates.reduce((best, value) => (value > best ? value : best), 0);
};

export const isLibraryInitialSave = (item) => {
  const created = parseLibraryTime(item?.created_at || item?.createdAt);
  const updated = resolveLibraryUpdatedAt(item);
  if (!updated) return true;
  if (!created) return true;
  return Math.abs(updated - created) < INITIAL_SAVE_MS;
};

const relativePhrase = (diffMs, suffix, when) => {
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return suffix === '수정' ? '방금 수정' : '저장';
  if (diffMin < 60) return `${diffMin}분 전 ${suffix}`;
  const diffHour = Math.floor(diffMin / 60);
  if (diffHour < 24) return `${diffHour}시간 전 ${suffix}`;
  const diffDay = Math.floor(diffHour / 24);
  if (diffDay < 7) return `${diffDay}일 전 ${suffix}`;
  const stamp = `${when.getFullYear()}.${String(when.getMonth() + 1).padStart(2, '0')}.${String(when.getDate()).padStart(2, '0')}`;
  return `${stamp} ${suffix}`;
};

export const formatLibraryTimestamp = (item, now = new Date()) => {
  const updated = resolveLibraryUpdatedAt(item);
  if (!updated) return '';
  const nowMs = now instanceof Date ? now.getTime() : parseLibraryTime(now);
  const diffMs = Math.max(0, nowMs - updated);
  return relativePhrase(diffMs, isLibraryInitialSave(item) ? '저장' : '수정', new Date(updated));
};

export const sortLibraryItemsByUpdatedAt = (items) => {
  if (!Array.isArray(items)) return [];
  return [...items].sort((left, right) => resolveLibraryUpdatedAt(right) - resolveLibraryUpdatedAt(left));
};

export { parseLibraryTime };
